import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { getDatabase, ref, child, get, onValue, set } from "firebase/database";
import { BehaviorSubject } from 'rxjs';
import { ApiUrlService } from 'src/services/api-url.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { FetchService } from './fetch.service';
import { TranslationService } from './translation.service';
import { CustomizationStoreService } from './customization.store.service';
import { mergeFlowCustomizationWithDefaults } from 'src/entity/customization-defaults';

@Injectable({
    providedIn: 'root'
})
export class CustomizationService {

    db = getDatabase();
    _custommization = new BehaviorSubject(null);



    constructor(public utils: UtilsService, private http: HttpClient, private localFetch: FetchService, private translationService: TranslationService, public customizationStore: CustomizationStoreService, private apiUrlService: ApiUrlService) {}

    /** Evita `texts` u otros bloques nulos en respuestas de `/customization/flow/...`. */
    private withFlowCustomizationDefaults(d: any): any {
        if (!d || typeof d !== 'object') {
            return d;
        }
        const next = { ...d };
        if (next.data != null && typeof next.data === 'object') {
            next.data = mergeFlowCustomizationWithDefaults(next.data);
        }
        return next;
    }

    bindCustomizationFromFirebase(idUser) {
        const starCountRef = ref(this.db, `customization/${idUser}`);
        onValue(starCountRef, (snapshot) => {
            const data = snapshot.val();
            this._custommization.next(data);
        });
    }

    getCustomization(funderID, flow?) {

        return new Promise((resolve, reject) => {
            const funderStyles = this.getFunderStyles(funderID);
            const funderConfig = this.getFunderConfig(funderID);
            const flowConfig = this.getCustomizationByFlow(funderID, flow);
            Promise.all([funderStyles, funderConfig, flowConfig]).then(d => {
                console.log('promise all: ', d)
            })
            this.http.get(this.apiUrlService.baseUrl + '/users/' + funderID + '/customization').subscribe((d: any) => {
                if(d) {
                    resolve(d);
                } else {
                    reject(d);
                }
            }, e => {
                reject(e)
            });
        });
    }

    getFunderConfig(funderID) {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiUrlService.baseUrl + '/users/' + funderID + '/customization/config').subscribe((d: any) => {
                if(d) {
                    resolve(d);
                } else {
                    reject(d);
                }
            }, e => {
                reject(e)
            });
        });
    }

    getFunderStyles(funderID) {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiUrlService.baseUrl + '/users/' + funderID + '/customization/style').subscribe((d: any) => {
                if(d) {
                    resolve(d);
                } else {
                    reject(d);
                }
            }, e => {
                reject(e)
            });
        });
    }

    getFlowTerms(funderID, flowName, requestID, reqIdString?) {
        let reqString = reqIdString || 'request_id';
        return new Promise((resolve, reject) => {
            this.http.get(`${this.apiUrlService.baseUrl}/users/${funderID}/customization/flow-terms/${flowName}?${reqString}=${requestID}`).subscribe((d: any) => {
                if(d) {
                    resolve(d);
                } else {
                    reject(d);
                }
            }, e => {
                reject(e)
            });
        });
    }

    getRequestIdString(requestStatus, flow) {
      if(requestStatus === 'prerequest') {
        if(flow && flow === 'SmsPin') {
          return 'prerequest_combined_flows_id';
        }
        return 'prerequest_id';
      }
      return 'request_id';
    }

    getCustomizationByFlow(funderID, flow, lang?, requestID?, requestStatus?, translate = false) {
        return new Promise((resolve, reject) => {
            let url = this.apiUrlService.baseUrl + '/users/' + funderID + '/customization/flow/' + flow;
            if(requestID) {
              let reqString = this.getRequestIdString(requestStatus, flow);
                url += '?' + reqString + '=' + requestID;
            }
            this.http.get(url).subscribe(async (d: any) => {
                if(d) {
                    if(d.data && lang && translate && this.translationService.isNonSpanishLanguage(lang)) {

                        this.translationService.getTraductionFromApi(funderID, flow, lang).then((trad: any) => {
                            if (trad?.data) {
                                if (trad.data.texts) {
                                    d.data.texts = { ...trad.data.texts };
                                }
                                const cfgTr = trad.data.config_translate;
                                if (cfgTr && typeof cfgTr === 'object') {
                                    d.data.config_translate = {
                                        ...(d.data.config_translate || {}),
                                        ...cfgTr,
                                    };
                                }
                                const policyFromTranslate = cfgTr?.policy;
                                if (policyFromTranslate && !d.data.texts?.policy) {
                                    d.data.texts.policy = policyFromTranslate;
                                }

                                const dataAssignmentFromTranslate = cfgTr?.dataAssignmentText;
                                if (dataAssignmentFromTranslate) {
                                    if (!d.data.texts) {
                                        d.data.texts = {};
                                    }
                                    d.data.texts.dataAssignmentText = dataAssignmentFromTranslate;
                                }

                                const policyText = d.data.texts?.policy || policyFromTranslate;
                                if (policyText) {
                                  this.customizationStore.setPolicy(policyText);
                                }

                                if (trad.data.texts?.terms_and_conditions) {
                                  this.customizationStore.setTerms(trad.data.texts.terms_and_conditions);
                                }
                            }
                            resolve(this.withFlowCustomizationDefaults(d));
                        }).catch(() => {
                            resolve(this.withFlowCustomizationDefaults(d))
                        })

                    } else {
                        resolve(this.withFlowCustomizationDefaults(d));
                    }

                } else {
                    reject(d);
                }
            }, e => {
                reject(e)
            });
        });
    }

    subscribeCustomization() {
        return this._custommization.asObservable();
    }

    saveCustomization(funderID, obj) {
        const db = getDatabase();
        set(ref(db, 'customization/' + funderID), obj);
        return new Promise((resolve, reject) => {
            this.localFetch.post(this.apiUrlService.baseUrl + '/funders/' + funderID + '/customization' , obj).then(d => {
                if(d) {
                    resolve(d);
                } else {
                    reject(false);
                }
            }).catch(e => {
                reject(e)
            });
        });


    }
}
